import React from 'react';

interface BooleanFormatterProps {
  value: boolean;
}

const BooleanFormatter: React.FC<BooleanFormatterProps> = ({ value }) => {
  return <pre>{value ? 'true' : 'false'}</pre>;
};

export default BooleanFormatter;
